import React from "react";

interface SizeProps {
  height?: string;
  width?: string;
  background?: boolean;
}

export default function TradeIcon(props: SizeProps) {
  return (
    <svg
      width={props.height ? props.height : "40px"}
      height={props.width ? props.width : "40px"}
      viewBox="0 0 40 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Designs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Mobile---Transactions:-Trade-Detail---Sell-+-buy-expanded"
          transform="translate(-47.000000, -190.000000)"
        >
          <g id="Trade" transform="translate(47.000000, 187.000000)">
            <g id="Group" transform="translate(0.000000, 3.000000)">
              <circle id="Oval" fill="#002035" cx="20" cy="20" r="20"></circle>
              <g
                transform="translate(7.500000, 7.500000)"
                id="Icons-/-Line-/-Trade"
                stroke="#FFFFFF"
                strokeLinejoin="round"
                strokeWidth="1.5"
              >
                <g>
                  <ellipse
                    id="Oval"
                    strokeLinecap="round"
                    cx="7.4999998"
                    cy="8.5"
                    rx="7.4999998"
                    ry="7.5"
                  ></ellipse>
                  <path
                    d="M14.9319996,9.461 C18.0084015,8.33987456 21.4565256,9.34406719 23.4499287,11.9416652 C25.4433317,14.5392631 25.5212081,18.1297922 23.6423075,20.8113782 C21.7634068,23.4929642 18.3620655,24.6457176 15.2399466,23.6590345 C12.1178276,22.6723513 9.99665622,19.7743182 9.99999579,16.5 C10.0023895,16.1785536 10.0251014,15.85758 10.0679997,15.539"
                    id="Path"
                  ></path>
                  <polyline
                    id="Path"
                    strokeLinecap="round"
                    points="24.9999993 5 22.9999994 8 20.9999994 5"
                  ></polyline>
                  <path
                    d="M14.9999996,0 L18.9999996,0 C21.2091384,0 22.9999996,1.790861 22.9999996,4 L22.9999996,8"
                    id="Path"
                    strokeLinecap="round"
                  ></path>
                  <polyline
                    id="Path"
                    strokeLinecap="round"
                    points="0 20 1.99999995 17 3.9999999 20"
                  ></polyline>
                  <path
                    d="M9.99999995,25 L5.99999995,25 C3.7908609,25 1.99999995,23.209139 1.99999995,21 L1.99999995,17"
                    id="Path"
                    strokeLinecap="round"
                  ></path>
                  <path
                    d="M5.09399987,6.312 L8.37499978,6.312 C8.97919926,6.312 9.46899971,6.8018005 9.46899971,7.406 C9.46899971,8.0101995 8.97919926,8.5 8.37499978,8.5"
                    id="Path"
                    strokeLinecap="round"
                  ></path>
                  <path
                    d="M5.09399987,10.688 L8.81199977,10.688 C9.41619927,10.688 9.90599974,10.1981995 9.90599974,9.594 C9.90599974,8.98980048 9.41619927,8.5 8.81199977,8.5 L5.96899984,8.5"
                    id="Path"
                    strokeLinecap="round"
                  ></path>
                  <line
                    x1="5.96799984"
                    y1="6.313"
                    x2="5.96799984"
                    y2="10.688"
                    id="Path"
                    strokeLinecap="round"
                  ></line>
                  <line
                    x1="6.29299984"
                    y1="6.313"
                    x2="6.29299984"
                    y2="5"
                    id="Path"
                    strokeLinecap="round"
                  ></line>
                  <line
                    x1="8.26599978"
                    y1="6.313"
                    x2="8.26599978"
                    y2="5"
                    id="Path"
                    strokeLinecap="round"
                  ></line>
                  <line
                    x1="6.29299984"
                    y1="12"
                    x2="6.29299984"
                    y2="10.688"
                    id="Path"
                    strokeLinecap="round"
                  ></line>
                  <line
                    x1="8.26599978"
                    y1="12"
                    x2="8.26599978"
                    y2="10.688"
                    id="Path"
                    strokeLinecap="round"
                  ></line>
                  <path
                    d="M19.1689995,14.319 L16.9439996,14.319 C16.546527,14.3069623 16.1739854,14.5121375 15.9716926,14.8544926 C15.7693999,15.1968476 15.7693999,15.6221524 15.9716926,15.9645074 C16.1739854,16.3068625 16.546527,16.5120377 16.9439996,16.5 L18.0559995,16.5 C18.4534721,16.4879623 18.8260137,16.6931375 19.0283064,17.0354926 C19.2305992,17.3778476 19.2305992,17.8031524 19.0283064,18.1455074 C18.8260137,18.4878625 18.4534721,18.6930377 18.0559995,18.681 L15.8309996,18.681"
                    id="Path"
                    strokeLinecap="round"
                  ></path>
                  <line
                    x1="17.4999995"
                    y1="13"
                    x2="17.4999995"
                    y2="14.319"
                    id="Path"
                    strokeLinecap="round"
                  ></line>
                  <line
                    x1="17.4999995"
                    y1="18.681"
                    x2="17.4999995"
                    y2="20"
                    id="Path"
                    strokeLinecap="round"
                  ></line>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
